import { CircularProgress, MenuItem, Select } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import { languages } from 'globals-variables';
import { TableColumns } from 'helpers/tableColumns';
import { useRemoteResource } from 'hooks/useRemoteResource';
import ZikrsSAService from 'services/superadmin/zikrsSAService';
import { useState } from 'react';

const listConfig = [
    {
        key: "order",
        label: "#",
        render: (_, index) => index + 1
    },
    {
        key: 'name',
        label: 'Название'
    },
    {
        key: "arabicText",
        label: "Арабский текст",
    },
    {
        key: "transcription",
        label: "Транскрипция",
    },
    {
        key: "translation",
        label: "Перевод",
    },
    {
        key: "count",
        label: "Количество",
    },
    {
        key: "language",
        label: "Язык",
    },
    TableColumns.createdDate,
]

export const ZikrList = () => {
    const [data, loadData, loading] = useRemoteResource(ZikrsSAService.getAll, "");

    const [language, setLanguage] = useState("");

    const onDelete = async (u) => {
        await ZikrsSAService.delete(u.id);
        loadData();
    };

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Список зикров">
            <div className="flex gap-8 mb-8" style={{ marginBottom: "32px" }}>
                <div>
                    <label>Язык</label>
                </div>
                <select
                    onChange={e => setLanguage(e.target.value)}
                    label="Язык"
                    value={language}
                >
                    <option value="">Все</option>
                    {languages.map(l => (
                        <option key={l.key} value={l.key}>{l.label}</option>
                    ))}
                </select>
            </div>
            <AppAdminTable
                columnConfig={listConfig}
                data={data?.filter(zikr => !language || zikr.language === language) || []}
                onDelete={onDelete}
                loading={loading}
            />
        </ListPage>
    );
}
